import ApiManager from './ApiManager';
import {JOB_STATE_COMPLETE, JOB_STATE_FAILED, JOB_STATE_INCOMPLETE} from "../const/job.const";
import {EventBus} from "../events/event.bus";
import {EVENT_JOB_FAIL} from "../events/job.events";
import {useCreatorStudioStore} from "../stores/CreatorStudioStore";
import {decodeBase64ToImageUrl, encodeImageToBase64} from "../../../../../helper/base64";

class SimiliarImageManager {
    listener = false;

    constructor() {
    }

    async loadOriginalImage(job, files) {
        this.store = useCreatorStudioStore();
        let storeJob = this.store.getJobById(job.id);

        this.store.creatorStudio.settings.similiarImageJob.apiJob = {
            status: {
                code: 'incomplete'
            }
        };

        let thumbnailJob = await ApiManager.create({'operation': 'system thumbnail preview'});

        if (null === thumbnailJob) {
            this.store.creatorStudio.settings.similiarImageJob.apiJob = null;
            return;
        }

        this.store.creatorStudio.settings.similiarImageJob.apiJob = thumbnailJob;

        await ApiManager.uploadInputs(thumbnailJob, {}, files);

        await ApiManager.start(thumbnailJob, {
            target: 'jpg',
            category: 'image',
            options: {
                'width': 1100
            },
        }).catch((e) => {
            return;
        });

        await this._waitUntilComplete(thumbnailJob);

        let finalJob = await ApiManager.get(thumbnailJob);

        this.store.creatorStudio.settings.similiarImageJob.apiJob = finalJob;

        let base64Image = await this._getBase64Image(finalJob.output[0].uri);
        this.store.creatorStudio.settings.similiarImageJob.base64 = base64Image;
    }

    async _getBase64Image(url) {
        return new Promise((resolve, reject) => {
            let uri = url;
            encodeImageToBase64(uri).then((base64String) => {
                resolve(decodeBase64ToImageUrl(base64String));
            });
        });
    }

    async _waitUntilComplete(job, incomplete = 0) {
        return new Promise((resolve, reject) => {

            async function _waitUntilComplete(job, incomplete = 0) {
                let apiJob = await ApiManager.get(job);
                if (null === apiJob) {
                    resolve();

                    return;
                }

                if (apiJob.status.code === JOB_STATE_FAILED) {
                    EventBus.$emit(EVENT_JOB_FAIL, {});

                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_COMPLETE) {
                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_INCOMPLETE) {
                    if (incomplete > 60) {
                        job.state = JOB_STATE_FAILED;

                        resolve();
                        return;
                    }

                    setTimeout(() => {
                        _waitUntilComplete(job, ++incomplete);
                    }, 2100);
                    return;
                }

                setTimeout(() => {
                    _waitUntilComplete(job);
                }, 2100);

                return;
            }

            _waitUntilComplete(job, incomplete);
        })
    }

}

export default new SimiliarImageManager();